import { Box, FieldWrapper, Text } from '@dixa/lib-shared-habla';
import { useFormContext } from 'react-hook-form';

import { CustomFieldEntity } from 'apis/customFields';
import { HookFormSwitch } from 'components/hookForm';

import { AttributeFormFieldValues } from '../../../customAttributeModalForm.types';

const genericDescription =
  'To ensure you have comprehensive data to further reporting.';

const entityDetails: Record<CustomFieldEntity, string | null> = {
  conversation: `${genericDescription} It only applies to claimed conversations. When required, wrap-up time will not stop until this attribute is filled in by the agent. The conversation will remain on the left-side bar until then for agents to find them.`,
  contact: null,
};

type RequiredFormFieldProps = {
  /** The entity id. */
  entityId: CustomFieldEntity;
};

/** Represents the field for setting the required state of a custom attribute. */
export const RequiredFormField = ({
  entityId,
}: RequiredFormFieldProps): JSX.Element => {
  const {
    control,
    // TODO: [TEAMS-13693] remove omit after updating to RHF v8
  } = useFormContext<Omit<AttributeFormFieldValues, 'options'>>();

  const details = entityDetails[entityId];

  return (
    <FieldWrapper label="Required for agents to fill" labelFor="is_required">
      <Box padding="0 0 250">
        <Text.Paragraph variant="4" subdued>
          {details}
        </Text.Paragraph>
      </Box>

      <HookFormSwitch control={control} name="is_required" />
    </FieldWrapper>
  );
};
